import { IEnv } from "../../../shared/interfaces/IEnv";

export default {
    client: {
        name: "tamarana",
        nomePrefeitura: "Prefeitura Municipal de Tamarana",
        logo: "tamarana/logos/logo_tamarana1.png",
        brasao: "tamarana/logos/logo_tamarana1.png",
        municipio: "| TAMARANA - PR",
    },
    webgeo: {
        allowMapDragAtAnyZoom: true,
        coordinatesPattern: "EPSG:32722",
        bci: {
            nomeSecretaria: "Secretaria Municipal de Gestão Pública e Finanças",
        },
        confrontante: {
            informacoesRodape: "",
            nomeSecretaria:
                "Secretaria Municipal de Desenvolvimento Urbano e Logística",
        },
        consultaPrevia: {
            nomeSecretaria: "Secretaria Municipal de Urbanismo",
            contact: {
                email: "xxx",
                endereco: "xxx",
                horarioAtendimento: "xxx",
                telefone: "xxx",
            },
            leiUsoDeSolo:
                "PARÂMETROS DE USO DO SOLO - Anexo (X) - Lei no XXXX/XXXX",
            leiVagasDeEstacionamento:
                "VAGAS PARA ESTACIONAMENTO anexo à lei XXXX/XXXXX",
        },
        config: {
            bci: true,
            confrontante: true,
            consultaPrevia: false,
            iptu: false,
            laws: false,
        },
        map: {
            center: [-51.0944317, -23.72825],
            zoom: 18,
        },
    },
    api: {
        url: "http://localhost:3330",
    },
    geoserver: {
        url: "https://geoserversp.semv.com.br/geoserver",
        ortoUrl: "https://geoserver-orto.semv.com.br/geoserver",
    },
} as IEnv;
